// extracted by mini-css-extract-plugin
module.exports = {"colored":"Template_colored__bJdLP","linklist":"Template_linklist__3fcAJ"};